export const SHOW_CUSTOMIZED_MESSAGE = 'SHOW_CUSTOMIZED_MESSAGE';
export const HIDE_CUSTOMIZED_MESSAGE = 'HIDE_CUSTOMIZED_MESSAGE';
export const UPDATE_CUSTOMIZED_MESSAGE_DATA='UPDATE_CUSTOMIZED_MESSAGE_DATA'
export const showCustomizedMessage = ()=>(dispatch) => { 
    dispatch({
        type: SHOW_CUSTOMIZED_MESSAGE,
        payload: {showMessage: true}
      });
};
export const hideCustomizedMessage = () => ({
    type: HIDE_CUSTOMIZED_MESSAGE,
    payload: {
        showMessage:false
    }
})
export const updateCustomizedMessage = (message,icon,color,textColor) => ({
    type: UPDATE_CUSTOMIZED_MESSAGE_DATA,
    payload: {
        message:message,
        icon:icon,
        color:color,
        textColor:textColor
    }
})


